import { t } from 'i18next';

import { AppDispatcher } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { CatalogActions } from './CatalogActions';
import { GlobalHelper } from '../utils/GlobalHelper';
import { SelectBoxStoreState, SelectBoxOption, SelectBoxStore } from '../stores/SelectBoxStore';

import eaiws = egr.wcf.eaiws;

export class SelectBoxActions {
    public static closeSelectBox(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SHOW_SELECTBOX,
            value: {options: [], title: '', sender: 0, value: 0}
        });
    }

    public static showSelectBox(value: SelectBoxStoreState): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SHOW_SELECTBOX,
            value: value
        });
    }

    public static showCatalogMenu(label: string, catalogPath: Array<eaiws.catalog.CatalogItem>): void {
        const tResult: Array<SelectBoxOption> = [];
        for (let tCatalogId: number = 1; (tCatalogId) < catalogPath.length; tCatalogId++) {
            let itemLabel: string = catalogPath[tCatalogId - 1].label;
            if (!itemLabel) {
                itemLabel = catalogPath[tCatalogId - 1].name;
            }
            tResult.unshift({
                key: 'catalog_' + tCatalogId.toString(),
                name: itemLabel,
                className: 'folder',
                icon: 'icon-folder',
                callback: () => {CatalogActions.enterPath(catalogPath.slice(0, tCatalogId)); }
            });
        }
        tResult.push({
            name: t('Catalog overview'),
            className: 'catalogs',
            key: 'catalogs',
            icon: 'icon-catalogs',
            callback: () => {CatalogActions.enterPath(catalogPath.slice(0, 0)); }
        });
        SelectBoxActions.showSelectBox({
            options: tResult,
            title: label,
            sender: 'catalogselect',
            value: null,
            asOverlay: true
        });
    }

    public static showCameraSelection(): void {
        SelectBoxActions.showSelectBox({
            options: SelectBoxStore.getCameraOptions(),
            title: t('Camera'),
            sender: 'camera-select',
            value: GlobalHelper.coreApp.viewer.activeView ? GlobalHelper.coreApp.viewer.activeView.cameraControl.cameraMode : null,
            asOverlay: false
        });
    }

    public static setActiveSelectBox(value: string | number | null): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_ACTIVE_SELECTBOX,
            value: value
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/SelectBoxActions.ts